import { Injectable } from '@angular/core'
import { AngularFireDatabase } from '@angular/fire/compat/database'

@Injectable({
  providedIn: 'root',
})
export class GameDataService {
  constructor(private db: AngularFireDatabase) {}

  savePlayerAgreements(
    userId: string,
    isPrivacyPolicyAccepted: boolean,
    isTermsAndConditionsAccepted: boolean
  ): Promise<void> {
    const path = `game-data/${userId}/playerAggrements`
    const data = {
      isPrivacyPolicyAccepted,
      isTermsAndConditionsAccepted,
    }
    return this.db.object(path).set(data)
  }
}